import React, { useEffect, useState } from 'react'
import { H2, H6 } from '../headings/index'
import Container from '../container/index'
import { ReactComponent as GoCredPago } from '../../images/go.svg'
import { PostsTitleWrapper, PostLink, CarouselWrapper } from './style'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

const BlogPost = ({ post }) => {

  const extract = date => date.toISOString().split(/[^0-9]/).slice(0, -1);
  const postDate = extract(new Date(post.date))

  return (
    <div>
      <PostLink href={post.link} target="_blank" rel="noreferrer" alt={post.title.rendered} title={post.title.rendered}>
        <img src={post.fimg_url || "//placehold.it/285x285?text=Carregando..."} alt={post.title.rendered || "Carregando..."} />
        <div>
          {post.date && (
            <time>{postDate[2]}/{postDate[1]}</time>
          )}          
          <H6 weight={800}>{post.title.rendered}</H6>
          <p>Leia mais →</p>
        </div>
      </PostLink>
    </div>
  )
}

const Posts = props => {

  const [ blogPosts, updateBlogPosts ] = useState([])

  useEffect( () => {

    fetch('https://blog.credpago.com.br/?rest_route=/wp/v2/posts&per_page=12')
      .then(response => {
        return response.json()
      })
      .then(response => {
        updateBlogPosts(response);
      })
  }, []);

  return (
    <Container>
      <PostsTitleWrapper>
        {/*<img src={GoCredPago} alt="CredPago" width="70" />*/}
        <GoCredPago />
        <H2 weight={800} fontStyle="italic">Fique por dentro das novidades do mercado</H2>
      </PostsTitleWrapper>
      <CarouselWrapper>
        <Carousel 
          draggable={false} 
          showDots={true} 
          renderDotsOutside={true}
          responsive={responsive} 
          removeArrowOnDeviceType={['mobile', 'tablet', 'desktop']}>
          {blogPosts.map( (item, index) => {
            return <BlogPost key={index} post={item} />
          })}
        </Carousel>
      </CarouselWrapper>
    </Container>
  )
}

export default Posts